module.exports = __webpack_public_path__ + "static/media/ca.346647e1.svg";